import { render, staticRenderFns } from "./OngoingBulk.vue?vue&type=template&id=3a54233c&"
import script from "./OngoingBulk.vue?vue&type=script&lang=js&"
export * from "./OngoingBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports